<app-demo-and-proofs>
  <app-action-buttons (resetAll)="resetAll()" (saveToSpaces)="openSaveToSpaces()"></app-action-buttons>
</app-demo-and-proofs>
